import axios from "axios";
import config from "@/config";
import { notify } from "../toast";

const api = axios.create({
  baseURL: config.api,
  timeout: config.timeout,
});

const abortController = new AbortController();

api.interceptors.request.use(
  (conf) => {
    const token = localStorage.getItem("token");
    if (token) {
      conf.headers.Authorization = `Bearer ${token}`;
    }
    return conf;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (response.data?.isValid === false) {
      // Throw error to be caught in .catch()
      return Promise.reject({ customError: true, info: response.data.info });
    }
    return response;
  },
  (error) => {
    notify(error?.response?.data?.data || error?.response?.data?.info || error?.response?.data?.Error  || "Dogodila se greška prilikom slanja podataka");
    return Promise.reject(error);
  }
);

export default {
  api,
  // Activities
  getActivityById(activityId) {
    return api({
      method: "GET",
      url: `/Activity/${activityId}`,
    });
  },
  getActivities(payload) {
    return api({
      method: "POST",
      url: "/Activity/get-activities",
      data: payload,
    });
  },
  createActivity(payload) {
    return api({
      method: "POST",
      url: "/Activity",
      data: payload,
    });
  },
  updateActivity(activityId, payload) {
    return api({
      method: "PUT",
      url: `/Activity/${activityId}`,
      data: payload,
    });
  },
  deleteActivities(payload) {
    return api({
      method: "DELETE",
      url: "/Activity/delete-activities",
      data: payload,
    });
  },

  //Area of operations
  getAreaOfOperationById(areaOfOperationId) {
    return api({
      method: "GET",
      url: `/AreaOfOperations/${areaOfOperationId}`,
    });
  },
  getAreaOfOperations(payload) {
    return api({
      method: "POST",
      url: "/AreaOfOperations/get-area-of-operations",
      data: payload,
    });
  },
  createAreaOfOperation(payload) {
    return api({
      method: "POST",
      url: "/AreaOfOperations",
      data: payload,
    });
  },
  updateAreaOfOperation(areaOfOperationId, payload) {
    return api({
      method: "PUT",
      url: `/AreaOfOperations/${areaOfOperationId}`,
      data: payload,
    });
  },
  deleteAreasOfOperation(payload) {
    return api({
      method: "DELETE",
      url: "/AreaOfOperations",
      data: payload,
    });
  },

  // Dashboard
  getLatestAssociations(){
    return api({
      method: "GET",
      url: `/Dashboard/get-latest-associations`,
    });
  },
  getAssociationsByYear(){
    return api({
      method: "GET",
      url: `/Dashboard/get-associations-by-year`,
    });
  },
  getNewAssociationsByYear(){
    return api({
      method: "GET",
      url: `/Dashboard/get-new-associations-by-year`,
    });
  },
  getAssociationsByPlace(){
    return api({
      method: "GET",
      url: `/Dashboard/get-associations-by-place`,
    });
  },
  getUpdatedAssociationsByYear(){
    return api({
      method: "GET",
      url: `/Dashboard/get-updated-associations-by-year`,
    });
  },
  getActivityDistribution(){
    return api({
      method: "GET",
      url: `/Dashboard/get-activity-distribution`,
    });
  },
  getRepresentativesByYear(){
    return api({
      method: "GET",
      url: `/Dashboard/get-representatives-by-year`,
    });
  },

   // Associations
  getAssociationById(associationId) {
    return api({
      method: "GET",
      url: `/Association/${associationId}`,
    });
  },
  getAssociationActivities(associationId, payload) {
    return api({
      method: "POST",
      url: `/Association/${associationId}/get-association-activities`,
      data: payload,
    });
  },
  getAssociations(payload) {
    return api({
      method: "POST",
      url: "/Association/get-associations",
      data: payload,
    });
  },
  createAssociation(payload) {
    return api({
      method: "POST",
      url: "/Association",
      data: payload,
    });
  },
  updateAssociation(associationId, payload) {
    return api({
      method: "PUT",
      url: `/Association/${associationId}`,
      data: payload,
    });
  },
  deleteAssociations(payload) {
    return api({
      method: "DELETE",
      url: "/Association",
      data: payload,
    });
  },
  revertToPreviousState(associationId) {
    return api({
      method: "PUT",
      url: `/Association/${associationId}/revert-to-previous-state`
    });
  },
  setAssociationAsArchived(associationId){
    return api({
      method: "PUT",
      url: `/Association/${associationId}/set-association-as-archived`,
    });
  },
  returnAssociationFromArchive(associationId){
    return api({
      method: "PUT",
      url: `/Association/${associationId}/return-association-from-archive`,
    });

    
  },


getCancelledAssociationChanges(payload) {
  return api({
    method: "POST",
    url: "/Association/get-cancelled-association-changes",
    data: payload,
  });
},
exportAssociations(payload) {
  return api({
    method: "POST",
    url: "/Association/export-associations",
    data: payload,
    responseType: "blob",
  });
},





  // Asociation details
  getAssociationDetailsById(associationId) {
    return api({
      method: "GET",
      url: `/AssociationDetails/${associationId}`,
    });
  },
  updateAssociationDetails(associationId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationDetails/${associationId}/association-details`,
      data: payload,
    });
  },

  // Association extracts
  getAssociationExtractById(associationExtractId) {
    return api({
      method: "GET",
      url: `/AssociationExtract/${associationExtractId}`,
    });
  },
  getAssociationExtracts(payload) {
    return api({
      method: "POST",
      url: "/AssociationExtract/get-association-extracts",
      data: payload,
    });
  },
  getNextOrdinalNumber(payload) {
    return api({
      method: "POST",
      url: "/AssociationExtract/get-association-extracts-next-ordinal-number",
      data: payload,
    });
  },
  createAssociationExtract(payload) {
    return api({
      method: "POST",
      url: "/AssociationExtract",
      data: payload,
    });
  },
  updateAssociationExtract(associationExtractId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationExtract/${associationExtractId}`,
      data: payload,
    });
  },

  // Associations functions
  getAssociationFunctionById(associationFunctionId) {
    return api({
      method: "GET",
      url: `/AssociationFunction/${associationFunctionId}`,
    });
  },
  getAssociationFunctions(payload) {
    return api({
      method: "POST",
      url: "/AssociationFunction/get-association-functions",
      data: payload,
    });
  },
  getLastAssociationFunction(payload) {
    return api({
      method: "GET",
      url: "/AssociationFunction/last-added-function",
      data: payload,
    });
  },
  createAssociationFunction(payload) {
    return api({
      method: "POST",
      url: "/AssociationFunction",
      data: payload,
    });
  },
  updateAssociationFunction(associationFunctionId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationFunction/${associationFunctionId}`,
      data: payload,
    });
  },
  deleteAssociationFunctions(payload) {
    return api({
      method: "DELETE",
      url: "/AssociationFunction/delete-association-functions",
      data: payload,
    });
  },
  getAssociationLiquidations(associationId) {
    return api({
      method: "GET",
      url: `/Association/${associationId}/get-association-liquidations`,
    });
  },
  getAssociationRequests(associationId, payload) {
    return api({
      method: "POST",
      url: `/Association/${associationId}/get-association-requests`,
      data: payload,
    });
  },
  getAssociationsWithExpirationOfMandate(payload) {
    return api({
      method: "POST",
      url: "/Association/get-associations-with-expiration-of-mandate",
      data: payload,
    });
  },

  // Association history
  getAssociationHistoryById(associationHistoryId) {
    return api({
      method: "GET",
      url: `/AssociationHistory/${associationHistoryId}`,
    });
  },
  getAssociationHistory(payload) {
    return api({
      method: "POST",
      url: "/AssociationHistory/get-associations-history",
      data: payload,
    });
  },
  updateAssociationHistory(associationId, associationHistoryId, payload) {
    return api({
      url: `/AssociationHistory/${associationId}/${associationHistoryId}/update-association-history`,
      method: "PUT",
      data: payload,
    });
  },
  updateAssociationLiquidationHistory(associationId, associationHistoryId, payload) {
    return api({
      url: `/AssociationHistory/${associationId}/${associationHistoryId}/update-association-liquidation-history`,
      method: "PUT",
      data: payload,
    });
  },
  // Uređivanje ograničenog skupa polja na pregledu jedne (prijašnje) promjene - šalje JSON, dira samo taj historijski red.
  updateAssociationHistoryFields(associationId, associationHistoryId, payload) {
    return api({
      url: `/AssociationHistory/${associationId}/${associationHistoryId}/update-association-history-fields`,
      method: "PUT",
      data: payload,
    });
  },

  // Association liquidation reasons
  getAssociationLiquidationReasonById(associationLiquidationReasonId) {
    return api({
      method: "GET",
      url: `/AssociationLiquidationReason/${associationLiquidationReasonId}`,
    });
  },
  getAssociationLiquidationReasons(payload) {
    return api({
      method: "POST",
      url: "/AssociationLiquidationReason/get-association-liquidation-reason",
      data: payload,
    });
  },
  createAssociationLiquidationReason(payload) {
    return api({
      method: "POST",
      url: "/AssociationLiquidationReason",
      data: payload,
    });
  },
  updateAssociationLiquidationReason(associationLiquidationReasonId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationLiquidationReason/${associationLiquidationReasonId}`,
      data: payload,
    });
  },
  deleteAssociationLiquidationReasons(payload) {
    return api({
      method: "DELETE",
      url: "/AssociationLiquidationReason/delete-association-liquidation-reasons",
      data: payload,
    });
  },

  // Association media
  downloadAssociationFile(payload) {
    return api({
      method: "POST",
      url: `/AssociationMedia/download-file`,
      data: payload,
    });
  },

  // Association procedures
  getAssociationProcedureById(associationProcedureId) {
    return api({
      method: "GET",
      url: `/AssociationProcedure/${associationProcedureId}`,
    });
  },
  getAssociationProcedures(payload) {
    return api({
      method: "POST",
      url: "/AssociationProcedure/get-association-procedures",
      data: payload,
    });
  },
  createAssociationProcedure(payload) {
    return api({
      method: "POST",
      url: "/AssociationProcedure",
      data: payload,
    });
  },
  updateAssociationProcedure(associationProcedureId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationProcedure/${associationProcedureId}`,
      data: payload,
    });
  },
  deleteAssociationProcedures(payload) {
    return api({
      method: "DELETE",
      url: "/AssociationProcedure/delete-association-procedures",
      data: payload,
    });
  },

  // Association statuses
  getAssociationStatusById(associationStatusId) {
    return api({
      method: "GET",
      url: `/AssociationStatus/${associationStatusId}`,
    });
  },
  getAssociationStatuses(payload) {
    return api({
      method: "POST",
      url: "/AssociationStatus/get-association-statuses",
      data: payload,
    });
  },
  createAssociationStatus(payload) {
    return api({
      method: "POST",
      url: "/AssociationStatus",
      data: payload,
    });
  },
  updateAssociationStatus(associationStatusId, payload) {
    return api({
      method: "PUT",
      url: `/AssociationStatus/${associationStatusId}`,
      data: payload,
    });
  },
  deleteAssociationStatuses(payload) {
    return api({
      method: "DELETE",
      url: "/AssociationStatus/delete-association-statuses",
      data: payload,
    });
  },

  // Auth
  login(payload) {
    return api({
      method: "POST",
      url: "/Auth/login",
      data: payload,
    });
  },
  logout() {
    return api({
      method: "POST",
      url: "/Auth/logout",
    });
  },

  // Cantons
  getCantonById(cantonId) {
    return api({
      method: "GET",
      url: `/Canton/${cantonId}`,
    });
  },
  updateCanton(cantonId, payload) {
    return api({
      method: "PUT",
      url: `/Canton/${cantonId}`,
      data: payload,
    });
  },
  getCantons(payload) {
    return api({
      method: "POST",
      url: "/Canton/get-cantons",
      data: payload,
    });
  },
  createCanton(payload) {
    return api({
      method: "POST",
      url: "/Canton",
      data: payload,
    });
  },
  deleteCantons(payload) {
    return api({
      method: "DELETE",
      url: "/Canton/delete-cantons",
      data: payload,
    });
  },

  // Countries
  getCountryById(countryId) {
    return api({
      method: "GET",
      url: `/Country/${countryId}`,
    });
  },
  updateCountry(countryId, payload) {
    return api({
      method: "PUT",
      url: `/Country/${countryId}`,
      data: payload,
    });
  },
  getCountries(payload) {
    return api({
      method: "POST",
      url: "/Country/get-country",
      data: payload,
    });
  },
  createCountry(payload) {
    return api({
      method: "POST",
      url: "/Country",
      data: payload,
    });
  },
  deleteCountries(payload) {
    return api({
      method: "DELETE",
      url: "/Country/delete-states",
      data: payload,
    });
  },

  // Municipality
  getMunicipalityById(municipalityId) {
    return api({
      method: "GET",
      url: `/Municipality/${municipalityId}`,
    });
  },
  updateMunicipality(municipalityId, payload) {
    return api({
      method: "PUT",
      url: `/Municipality/${municipalityId}`,
      data: payload,
    });
  },
  getMunicipalities(payload) {
    return api({
      method: "POST",
      url: "/Municipality/get-municipalities",
      data: payload,
    });
  },
  createMunicipality(payload) {
    return api({
      method: "POST",
      url: "/Municipality",
      data: payload,
    });
  },
  deleteMunicipalities(payload) {
    return api({
      method: "DELETE",
      url: "/Municipality/delete-municipalities",
      data: payload,
    });
  },

  // Places
  getPlaceById(placeId) {
    return api({
      method: "GET",
      url: `/Place/${placeId}`,
    });
  },
  updatePlace(placeId, payload) {
    return api({
      method: "PUT",
      url: `/Place/${placeId}`,
      data: payload,
    });
  },
  getPlaces(payload) {
    return api({
      method: "POST",
      url: "/Place/get-places",
      data: payload,
    });
  },
  createPlace(payload) {
    return api({
      method: "POST",
      url: "/Place",
      data: payload,
    });
  },
  deletePlaces(payload) {
    return api({
      method: "DELETE",
      url: "/Place/delete-places",
      data: payload,
    });
  },

  // States
  getStateById(stateId) {
    return api({
      method: "GET",
      url: `/State/${stateId}`,
    });
  },
  updateState(stateId, payload) {
    return api({
      method: "PUT",
      url: `/State/${stateId}`,
      data: payload,
    });
  },
  getStates(payload) {
    return api({
      method: "POST",
      url: "/State/get-states",
      data: payload,
    });
  },
  createState(payload) {
    return api({
      method: "POST",
      url: "/State",
      data: payload,
    });
  },
  deleteStates(payload) {
    return api({
      method: "DELETE",
      url: "/State/delete-states",
      data: payload,
    });
  },

  //Association Requests
  getNextRequestOrdinalNumber(payload) {
    return api({
      method: "GET",
      url: "/AssociationRequest/get-association-requests-next-ordinal-number",
      data: payload,
    });
  },
  getRequests(payload) {
    return api({
      method: "POST",
      url: "/AssociationRequest/get-association-requests",
      data: payload
    });
  },
  getRequestById(requestId) {
    return api({
      method: "GET",
      url: `/AssociationRequest/${requestId}`,
    });
  },
  createRequest(payload) {
    return api({
      method: "POST",
      url: "/AssociationRequest",
      data: payload,
    })
  },
  updateRequest(payload) {
    return api({
      method: "PUT",
      url: `/AssociationRequest/${payload.id}`,
      data: payload,
    })
  },
  concludeRequest(payload, id) {
    return api({
      method: "PUT",
      url: `/AssociationRequest/${id}/conclude`,
      data: payload,
    })
  },
  deleteRequest(id) {
    return api({
      method: "DELETE",
      url: `/AssociationRequest/${id}/delete`,
    })
  },
 // Reports
  getAssociationsActivitiesReport(payload) {
    return api({
      method: "POST",
      url: "/reports/get-associations-activities",
      data: payload,
    });
  },
  getAssociationsHistoryReport(payload) {
    return api({
      method: "POST",
      url: "/reports/get-associations-history",
      data: payload,
    });
  },
  GetRequestStatistics(payload) {
    return api({
      method: "POST",
      url: "/reports/get-requests-stats",
      data: payload,
    });
  },
  GetAssociationHistoryDetailed(associationId) {
    return api({
      method: "GET",
      url: `/reports/get-association-history-detailed/${associationId}`,
    });
  },

  // Users
  getUserById(userId) {
    return api({
      method: "GET",
      url: `/users/${userId}`,
    });
  },
  getProfile() {
    return api({
      method: "GET",
      url: "/users/profile",
    });
  },
  getUsers(payload) {
    return api({
      method: "POST",
      url: "/users/get-users",
      data: payload,
    });
  },
  updateUser(userId, payload) {
    return api({
      method: "PUT",
      url: `/users/${userId}`,
      data: payload,
    });
  },
  updateProfile(id, payload) {
    return api({
      method: "PUT",
      url: `/users/${id}/update-profile`,
      data: payload,
    });
  },
  updatePassword(payload) {
    return api({
      method: "PUT",
      url: "/users/update-password",
      data: payload,
    });
  },
  createUser(payload) {
    return api({
      method: "POST",
      url: "/users",
      data: payload,
    });
  },
  deleteUsers(payload) {
    return api({
      method: "DELETE",
      url: "/users/delete-users",
      data: payload,
    });
  },
  checkEmail(payload) {
    return api({
      method: "POST",
      url: "/users/check-email",
      data: payload,
    });
  },
  checkUsername(payload) {
    return api({
      method: "POST",
      url: "/users/check-username",
      data: payload,
    });
  },

  // Roles
  getRolesDropdown() {
    return api({
      method: "GET",
      url: "/roles/dropdown",
    });
  },
  abortController,
};
